// Product page sticky column: keeps the buy box (and details beside it) in view while the gallery scrolls.
// When the pinned element is taller than the screen, its top offset goes negative so it scrolls to its
// bottom first and then pins, so nothing is ever cut off. The pinned element is this host, or the buy box
// when the host is display: contents (details placed below the gallery).
class StickyColumn extends HTMLElement {
  #observer = null;
  #onResize = () => this.#update();

  connectedCallback() {
    this.#observer = new ResizeObserver(this.#onResize);
    this.#observer.observe(this);
    const info = this.querySelector(':scope > .product-info');
    if (info) this.#observer.observe(info);
    window.addEventListener('resize', this.#onResize, { passive: true });
    this.#update();
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    window.removeEventListener('resize', this.#onResize);
  }

  #update() {
    const pinned = getComputedStyle(this).display === 'contents' ? this.querySelector(':scope > .product-info') : this;
    if (!pinned) return;
    const base = parseFloat(getComputedStyle(document.documentElement).fontSize) * 7;
    const room = window.innerHeight - pinned.offsetHeight - 24;
    this.style.setProperty('--sticky-top', `${Math.round(Math.min(base, room))}px`);
  }
}

if (!customElements.get('s-sticky-column')) customElements.define('s-sticky-column', StickyColumn);
